import React from "react";
import Footer from '../Components/Footer'
import NaviBarv2 from '../Components/NaviBarv2'
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import {Container, Row, Col, Card, ListGroup, ListGroupItem, Button, Tab, Nav,
OverlayTrigger, Popover, Placeholder} from 'react-bootstrap';
import conf_TheoryAndNumericalMethods2 from "../images/conf/conf_TheoryAndNumericalMethods2.png"


export function Conf_Astana () {
  return (
        <>
    <NaviBarv2 />
    <Container>
    <div><img src={conf_TheoryAndNumericalMethods2} align="left" width={500} ></img></div>
    <div class="row my-4 ps-4"><h2>Евразийская международная научная конференция «Искусственный интеллект и обратные задачи в науке, технике и индустрии».</h2></div>
    <div class="row ps-4 my-4"><p class="lead"></p></div>
    <div class="row ps-4 my-4"><p class="lead"></p></div>
    <div class="row ps-4 my-4"><p class="lead"></p></div>
    <div class="row ps-4 my-4"><p class="lead"></p></div>
    <div class="row ps-4 my-4"><p class="lead"></p></div>
    <hr></hr>
    <div class="row ps-4 my-4"><p class="lead">14-16 апреля 2025 года в НАО «Евразийский национальный университет имени Л. Н. Гумилева» состоится международная научная конференция «Искусственный интеллект и обратные задачи в науке, технике и индустрии», организуемой факультетом Информационных технологий.</p></div>
    <div class="row ps-4 my-4"><p class="lead">Целью конференции является объединение выдающихся ученых и молодых исследователей для обмена опытом, обсуждения новых результатов в следующих областях: искусственного интелекта, обратных и некорректных задачах естествознания; информационно-коммуникационных  технологий;  вычислительного  интеллекта в криптографии и кибербезопасности.</p></div>
    <div class="row ps-4 my-4"><p class="lead"><h3>Организационный комитет:</h3>
    <h4>Председатель:</h4></p></div>
    <div class="row ps-4 my-4"><p class="lead"><b>Сыдыков Е.Б. – </b> Председатель правления – Ректор. <br></br> 
    <div class="row ps-4 my-4"><p class="lead">
    <h4>Заместитель председателя:</h4></p></div>
    <b>Курмангалиева Ж.Д. – </b> проректор понауке и инновациям ЕНУ им. Л. Гумилева.<br></br> 
    <b>Айдаргалиева Н. Г. – </b> член правления-проректор по финансам и инвестициям ЕНУ им. Л.Н. Гумилева (Казахстан). <br></br> 
    <b>Бекманова Г. – </b> член правления -  проректор по цифровизации. <br></br> 
    <b>Сеилов Ш.Ж. – </b> д.э.н., декан ФИТ. <br></br> 
    <b>Искаков К.Т. – </b> д.ф.-м.н., профессор ЕНУ им. Л. Гумилева. <br></br> 
    <div class="row ps-4 my-4"><h4>Члены организационного коммитета:</h4></div>
    <b>Сейпишева А.Ю. – </b> начальник управление научных изданий и наукометрических ресурсов ЕНУ им. Л.Н. Гумилева (Казахстан). <br></br> 
    <b>Каматов Р.М. – </b> начальник управления науки и аттестации научных кадров ЕНУ им. Л.Н. Гумилева(Казахстан). <br></br> 
    <b>Жумадиллаева А.К. – </b> к.т.н., замдекана по науке факультета ФИТ. <br></br> 
    <b>Дюсекеев К.А. – </b> PhD, зав.каф. Компьютерной и Программной инженерии. <br></br> 
    <b>Маткаримов Б.Т. – </b> д.т.н., профессор кафедры Технологии искусственного интеллеекта. <br></br> 
    <b>Сатыбалдина Д.Ж. – </b> к.ф.-м.н., директор НИИ «Информационнойбезопасности и криптологии». <br></br> 
    <b>Раззахова Б.Ш. – </b> к.т.н., зав.каф. Технологии искусственного интеллеекта. <br></br> 
    <b>Атанов С.К. – </b> д.т.н., профессор кафедры Компьютерной и Программной инженерии. <br></br> 
    <b>Мирғалиқызы Т. – </b> PhD, доцент кафедры Компьютерной и Программной инженерии. <br></br> 
    <b>Байдильдинов М.О. – </b> к.т.н., доцент кафедры Компьютерной и Программной инженерии. <br></br> 
    <b>Глазырина Н.Т. – </b> PhD.,ассоциированный профессор кафедры Компьютерной и Программной инженерии. <br></br> 
    <b>Жартыбаева М.Г – </b> PhD., и.о. доцента кафедры Компьютерной и Программной инженерии. <br></br> 
    <b>Оралбекова Ж.О. – </b> PhD., ассоциированный профессор кафедры Компьютерной и Программной инженерии. <br></br> 
    <b>Есенгалиева Ж.С. – </b> PhD, доцент кафедры Компьютерной и Программной инженерии. <br></br> 
    <b>Муханова А. – </b> PhD, зав.каф. Информационной системы. <br></br>
    <b>Ускенбаева Г.А. – </b> PhD, зав.каф. Системного анализа и упралвения. <br></br> 
    <b>Шарипбаев А.А. – </b> д.т.н, профессор Информационной безопасности. <br></br> 
    <b>Конырханова А.А. – </b> PhD, зав.каф. Информационной безопасности. <br></br> 
    <b>Тусупов Д.А. – </b> д.ф.-м.н., профессор кафедры Информационной системы. <br></br> 
    <b>Бейсемби М. – </b> д.т.н., профессор Системного анализа и упралвения. <br></br> 
    <b>Оразбаев Б.Б. – </b> д.т.н., профессор Системного анализа и упралвения. <br></br>
    <b>Зулпыхар Ж.Е. – </b> к.т.н., зав.каф Информатики. <br></br> 
    <b>Серик М. – </b> д.п.н., профессор кафедры Информатики. <br></br> 
    <b>Ахмеджанов М. – </b> PhD, КазНУ им Аль-Фараби. <br></br> 
    <b>Аршидинова М.Т. – </b> PhD,ИИВТ КН МНВО РК. <br></br>
    </p></div>
    
    <div class="row ps-4 my-4"><p class="lead">Более подробная информация указана на <a rel="noopener" target="_blank" href="https://enu.kz/ru/events/1072?ysclid=m9cdbgde5a7154905">сайте конференции</a>.</p></div>
    <div class="row ps-4 my-4"><p>11.04.2025</p></div>
    </Container>
    <Footer />
    </>
    
    )}